document.addEventListener('DOMContentLoaded', function () {

  // --- Tabs click ---
  const tabs = document.querySelectorAll('.tab');
  const contents = document.querySelectorAll('.tab-content');
  const viewButtons = document.querySelectorAll('.view-product-btn');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const handle = this.dataset.product;

      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      viewButtons.forEach(b => b.classList.add('hidden'));

      this.classList.add('active');

      const activeContent = document.querySelector(`.tab-content[data-product="${handle}"]`);
      if (activeContent) activeContent.classList.add('active');

      const activeButton = document.querySelector(`.view-product-btn[data-product="${handle}"]`);
      if (activeButton) activeButton.classList.remove('hidden');
    });
  });

  // --- Tabs slider ---
  new Glide('.tabs-container.glide', {
    type: 'slider',
    perView: 2.5,    // 2.5 tabs visible
    gap: 10,
    bound: true,
    swipeThreshold: 80,
    dragThreshold: 120,
    focusAt: 0
  }).mount();

  // --- Gallery sliders ---
  document.querySelectorAll('.tab-content .glide').forEach((slider) => {
    new Glide(slider, {
      type: 'carousel',
      perView: 2,   // 1.5 images visible
      gap: 20,
      breakpoints: {
        768: { perView: 1.5 },
        480: { perView: 1.5 }
      }
    }).mount();
  });

});


document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.tab_gallery');
  if (!section) return;

  const tabsWrapper = section.querySelector('.tabs-wrapper');
  const leftArrow = section.querySelector('.left-arrow');
  const rightArrow = section.querySelector('.right-arrow');

  if (!tabsWrapper || !leftArrow || !rightArrow) return;

  const scrollAmount = 300;

  leftArrow.addEventListener('click', () => {
    tabsWrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    tabsWrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
});
